import api from '../../utils/api';
import {
    GET_LIST_MEDIA_CATEGORIES,
    GET_SPECIFIC_MEDIA_CATEGORIES,
    UPDATE_SPECIFIC_MEDIA_CATEGORIES,
    CREATE_NEW_MEDIA_CATEGORIES,
    REMOVE_MEDIA_CATEGORIES,
    GET_MEDIA_CATEGORIES_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListMediaCategories = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/media-categories', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_MEDIA_CATEGORIES, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificMediaCategories = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/media-categories/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_MEDIA_CATEGORIES, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getMediaCategoriesActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/media-categories/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_MEDIA_CATEGORIES_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createMediaCategories = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/media-categories', data).then(res => {
            dispatch({ type: CREATE_NEW_MEDIA_CATEGORIES, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateMediaCategories = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/media-categories/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_MEDIA_CATEGORIES, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeMediaCategories = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/media-categories`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_MEDIA_CATEGORIES, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
